import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { CalendarModule } from "primeng/calendar";
import { CalendarioComponent } from "./calendario.component";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    CalendarModule
  ],
  declarations: [CalendarioComponent],
  exports: [CalendarioComponent]
})
export class CalendarioModule { }
